import React, { useState } from "react";
import { useDrop } from "react-dnd";
import { IDropResult, IPlannerMinute, ITripPlanner, Iuser } from "../types/plannerTypes";
import { Targets } from "../../../common/dndHelper";
import PlannerTrip from "./PlannerTrip";
import clsx from "clsx";
import { getTimeLabel, LightTooltip } from "./plannerHelpers";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { showTripDetailsModal } from "../../../store/modules/plannerSliceModals";
import { MODAL_TYPE } from "./PlannerTripDetails";
import { setShowYellowBorder } from "../../../store/modules/plannerYellowBorderSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { checkAcuity, checkLocationPermission, checkuserpermission } from "../conflictNotices/conflictNoticeHelper";
import { ConflictDialogData, ConflictType, IntervalNumbers } from "../types/conflictNoticeTypes";
import { getData, getRoles, persistName, setData } from "../helpers/transferScheduleHelpers";
import { consts } from "../../../common/consts";
interface PlannerMinuteBoxProps {
  plannerMinute: IPlannerMinute;
  getMinuteStyle: any;
  applyTimelineChanges: any;
  showAdHocRequestModal: any;
  isPassed: boolean;
  blockLabel: string | null;
  isMutliloadAllowed: boolean | null;
  noOfStretchers: number;
  noOfPatientSeats: number;
  plannerAcuity: string | null;
  setConflictDialogData: any;
  userid:string|any;
  tripplaner:ITripPlanner;
  roles: any;
  selectedLocationId:string;
}

const useStyles = makeStyles({
  whiteBorder: {
    borderColor: "white !important",
  },
});

const PlannerMinuteBox: React.FC<PlannerMinuteBoxProps> = ({
  plannerMinute,
  getMinuteStyle,
  applyTimelineChanges,
  isPassed,
  blockLabel,
  showAdHocRequestModal,
  isMutliloadAllowed,
  noOfStretchers,
  noOfPatientSeats,
  plannerAcuity,
  setConflictDialogData,
  userid,
  tripplaner,
  roles,
  selectedLocationId,
}) => {
  // console.log("applyTimelineChanges");
  // console.log(plannerMinute);
  const [requestMobility, setRequestMobility] = useState<number>(2);
  const { plannerDraggingTripStore } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const { authStore } = useSelector((state: RootState) => state);
  const [role, setRoles] = React.useState<any>(getRoles(authStore));
  const [{ canDrop, isOver, didDrop, itemType }, drop] = useDrop(
    () => ({

      accept: "TransferRequest",
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
        didDrop: monitor.didDrop(),
        itemType: monitor.getItemType(),
      }),
      hover: (item: any, monitor) => {
        // 1 Not Ambulant
        // 2 Ambulant
        setRequestMobility(item?.mobility === 1 ? 1 : 2);
      },
      drop: (item, monitor) => {

        let _transferAcuityString = localStorage.getItem("transferAcuity");
        let _transferAcuityList = null;
        let _transferAcuity = item?.transferAcuity;
        if (_transferAcuityString && item?.from=="RequestedTransferItem") {
          _transferAcuityList = JSON.parse(_transferAcuityString);
          let _resultMap = new Map(Object.entries(_transferAcuityList));
          _transferAcuity=_resultMap.get(item.transferId);
        }
        setRoles(getRoles(authStore));
        var role ="";
          if(tripplaner.sharingRole === null)
          {
          role =consts.Permissions.Primary;
        }
        else{
          role =tripplaner.sharingRole;
        }
        var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
          if(superuser!== true)
          {
              if(authStore.data?.IsAdmin || authStore.data?.IsSMAUser)
              {
            const userper = checkuserpermission(tripplaner.sharingRole,role == consts.Permissions.Primary? Boolean(authStore.data?.role.split(",")?.
              some((p) => p == consts.Permissions.SMAAddtransfers)):(Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMAAddtransfersSecondary))));
            if (userper !== null) {
              setConflictDialogData(userper);
              return null;
            }
          }
          else{
            const userper = checkuserpermission(tripplaner.sharingRole,role == consts.Permissions.Primary? Boolean(authStore.data?.role.split(",")?.
              some((p) => p == consts.Permissions.Addtransfers)):(Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.AddtransfersSecondary))));
            if (userper !== null) {
              setConflictDialogData(userper);
              return null;
            }
          }
          }

        const isWrongAcuity = checkAcuity(plannerAcuity, _transferAcuity);

        if (isWrongAcuity !== null) {
          setConflictDialogData(isWrongAcuity);
          return null;
        }


        const rMobility = item?.mobility === 1 ? 1 : 2;
        if (plannerMinute && plannerMinute.trip && item.transferId !== plannerMinute.trip.virtualTripId) {
          let tripNoOfStretchers = 0;
          let tripNoOfPatient = 0;
          plannerMinute.trip.transfers.forEach((t) => {
            if (t.scheduleObj.mobility === 2) tripNoOfPatient += 1;
            if (t.scheduleObj.mobility === 1) tripNoOfStretchers += 1;
          });
          // 1 Not Ambulant
          // 2 Ambulant
          if ((rMobility === 2 && tripNoOfPatient >= noOfPatientSeats) || (rMobility === 1 && tripNoOfStretchers >= noOfStretchers)) {
            const dropResult: IDropResult = {
              target: Targets.PLANNER_TIMELINE_CANNOT_ADD,
              plannerMinute: plannerMinute,
              applyTimelineChanges: applyTimelineChanges,
            };
            return dropResult;
          }

          const isMultiloadNotAccepted = checkLocationPermission(isMutliloadAllowed, plannerMinute);
          if (isMultiloadNotAccepted !== null) {
            setConflictDialogData(isMultiloadNotAccepted);
            return null;
          }
        }
        const dropResult: IDropResult = {
          target: Targets.PLANNER_TIMELINE,
          plannerMinute: plannerMinute,
          applyTimelineChanges: applyTimelineChanges,
        };
        return dropResult;
      },
    }),
    [plannerMinute, applyTimelineChanges]
  );

  const isOverAndNoTrip = !!(
    isOver &&
    (!plannerMinute.trip || (plannerMinute.trip && plannerDraggingTripStore.draggingTripId === plannerMinute.trip.virtualTripId))
  );
  const isOverAndTrip = !!(isOver && plannerMinute.trip && plannerDraggingTripStore.draggingTripId !== plannerMinute.trip.virtualTripId);

  React.useEffect(() => {
    if (isOverAndTrip && isMutliloadAllowed) {
      setTimeout(() => {
        if (plannerMinute.trip) {
          let tripNoOfStretchers = 0;
          let tripNoOfPatient = 0;

          plannerMinute.trip.transfers.forEach((t) => {
            if (t.scheduleObj.mobility === 2) tripNoOfPatient += 1;
            if (t.scheduleObj.mobility === 1) tripNoOfStretchers += 1;
          });
          // 1 Not Ambulant
          // 2 Ambulant
          if ((requestMobility === 2 && tripNoOfPatient >= noOfPatientSeats) || (requestMobility === 1 && tripNoOfStretchers >= noOfStretchers)) {
            dispatch(
              showTripDetailsModal({
                showTripDetails: true,
                tripDetails: plannerMinute.trip,
                tripDetailsModalType: MODAL_TYPE.CANNOT_ADD,
                blockLabel: blockLabel,
                noOfStretchers: noOfStretchers,
                noOfPatientSeats: noOfPatientSeats,
              })
            );
          } else {
            dispatch(
              showTripDetailsModal({
                showTripDetails: true,
                tripDetails: plannerMinute.trip,
                tripDetailsModalType: MODAL_TYPE.DROP_TO_ADD,
                blockLabel: blockLabel,
                noOfStretchers: noOfStretchers,
                noOfPatientSeats: noOfPatientSeats,
              })
            );
          }
        }
      }, 1);
    }
    if (!isOverAndTrip) {
      dispatch(
        showTripDetailsModal({
          showTripDetails: false,
          tripDetails: null,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: null,
        })
      );
    }
  }, [isOverAndTrip]);

  React.useEffect(() => {
    dispatch(setShowYellowBorder(canDrop));
  }, [canDrop]);

  React.useEffect(() => {
    if ((didDrop && itemType == "TransferRequest") || isOverAndNoTrip) {
      dispatch(
        showTripDetailsModal({
          showTripDetails: false,
          tripDetails: null,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: null,
        })
      );
      localStorage.setItem('isReArranged', "false");
    }
  }, [didDrop, isOverAndNoTrip]);

    const classes = useStyles();

  return (
    <LightTooltip title={getTimeLabel(plannerMinute.date)} placement="top" open={isOverAndNoTrip}>
      <div
        ref={drop}
        key={plannerMinute.id}
        className={clsx(getMinuteStyle(plannerMinute.date), {
          [classes.whiteBorder]: isOverAndNoTrip,
        })}
      >
        {plannerMinute.trip && (
          <PlannerTrip
            plannerMinute={plannerMinute}
            isPassed={isPassed}
            showAdHocRequestModal={showAdHocRequestModal}
            blockLabel={blockLabel}
            noOfStretchers={noOfStretchers}
            noOfPatientSeats={noOfPatientSeats}
            tripplaner={tripplaner}
            setConflictDialogData={setConflictDialogData}
            selectedLocationId={selectedLocationId}
          />
        )}
      </div>
    </LightTooltip>
  );
};
export default PlannerMinuteBox;
